// extracted by mini-css-extract-plugin
module.exports = {"ul":"Lists-module--ul--1Lmlv","ol":"Lists-module--ol--V-E1U","li":"Lists-module--li--3miZh","checkList":"Lists-module--checkList--3N_PM"};